import React from 'react';
import { Switch } from 'sonata-react-components';

import { ActionButton, IconWrapper } from './ActionOptions.style';

export type Option = {
  icon?: string;
  id: string;
  loading?: boolean;
  onClick: () => void;
  text: string;
};

type Props = {
  buttonProps?: React.ComponentProps<typeof ActionButton>;
  className?: string;
  options: Option[];
};

export function ActionOptions({ buttonProps, className, options }: Props) {
  return (
    <>
      {options.map(option => (
        <ActionButton
          {...buttonProps}
          className={className}
          key={option.id}
          loading={!!option.loading}
          onClick={option.onClick}
        >
          <Switch>
            <Switch.Case condition={!!option.icon && !option.loading}>
              <IconWrapper className={option.icon} />
            </Switch.Case>
            <Switch.Case condition={!!option.icon && !!option.loading}>
              <IconWrapper className="fa-solid fa-spinner fa-spin" />
            </Switch.Case>
          </Switch>
          <span>{option.text}</span>
        </ActionButton>
      ))}
    </>
  );
}
